import React, { useMemo } from 'react';
import Auth from '.';
import { useSelector } from 'react-redux';
import { MainLayoutProps } from '../../Api/Interface/layout.interface';
import { useGetUserQuery } from '../../Api/attoDeskApi';
import { selectEnableAuth } from '../../Store/Auth/AuthSelector';
import { Loader } from '../../Components/Loader';
import { useLocation } from 'react-router-dom';

const LoginProvider = ({ children }: MainLayoutProps) => {
  const location = useLocation();

  const isPortalRoute =
    location.pathname.includes('/restaurant-portal/') ||
    location.pathname === '/restaurant-portal/login' ||
    location.pathname === '/player' ||
    location.pathname.startsWith('/player/') ||
    location.pathname === '/p' ||
    location.pathname.startsWith('/p/') ||
    location.pathname.startsWith('/installer') ||
    location.pathname.startsWith('/download/');

  // Skip admin auth query entirely on portal routes
  const { isLoading } = useGetUserQuery(undefined, { skip: isPortalRoute });
  const authEnable = useSelector(selectEnableAuth);

  const renderComponent = useMemo(() => {
    if (isPortalRoute) return children;
    if (isLoading) return <Loader />;
    return authEnable ? children : <Auth />;
  }, [isLoading, authEnable, children, isPortalRoute]);

  return <>{renderComponent}</>;
};

export default React.memo(LoginProvider);
